<template>
  <v-card flat class="mb-7">
    <v-card-text class="pa-5" v-if='ready'>
      <div class="d-md-flex align-center">
        <div>
          <h3 class="title font-weight-bold">Program Attendance </h3>
          <h6 class="subtitle-2 font-weight-light">Overview of Program Attendance</h6>
        </div>
        <v-spacer></v-spacer>
        <div class="ml-auto">
          <div class="d-flex align-center text-truncate text-nowrap">
            <div class="d-flex align-center px-2">
              <span class="info--text">
                <span class="overline">
                  <i class="fa fa-circle mx-2"></i>
                </span>
                <span class="font-weight-regular">Attendance</span>
              </span>
              <span class="success--text">
                <span class="overline">
                  <i class="fa fa-circle mx-2"></i>
                </span>
                <span class="font-weight-regular">Programs Logged</span>
              </span>
            </div>
            <div class="d-flex align-center px-2">
              <span class="info--text" v-if='showBars'>
                <span class="overline">
                  <i class="fa fa-circle mx-2"></i>
                </span>
                <span class="font-weight-regular">Programs Logged</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div style="max-height: 300px;" class="mt-5 mt-md-0">
        <!-- <vue-apex-charts
          type="area"
          height="285"
          :options="apexChartData.lineAreaChartSpline.chartOptions"
          :series="apexChartData.lineAreaChartSpline.series"
        ></vue-apex-charts> -->
        <vue-apex-charts
          type="area"
          height="285"
          :options="chartData[0]"
          :series="chartData[1]"
        ></vue-apex-charts>
      </div>
    </v-card-text>
    <v-card-text v-else>
      <h2 class='text-center'>Loading Chart....</h2>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import apexChartData from "../../../charts/apexcharts/ApexChartsData";

export default {
  props: {
    submissions:{
      type: Array
    }
  },
  name: "TheNewsletterCampaign",
  data: () => ({
    ready:false,
    showBars:false,
    apexChartData: apexChartData,
    atCount:{'Jul':0,'Aug':0,'Sep':0,'Oct':0,'Nov':0,'Dec':0,'Jan':0,'Feb':0,'Mar':0,'Apr':0,'May':0,'Jun':0},
    regCount:{'Jul':0,'Aug':0,'Sep':0,'Oct':0,'Nov':0,'Dec':0,'Jan':0,'Feb':0,'Mar':0,'Apr':0,'May':0,'Jun':0},
    months:['January','February','March','April','May','June','July','August','September','October','November','December'], 
  }),
  watch: {
    submissions() {
      this.ready = false;
      setTimeout(() => {
        this.ready = true
      }, 2000);
    }
  },
  computed:{
    chartData() {
      let apData = this.apexChartData;
    let atCount = {'Jul':0,'Aug':0,'Sep':0,'Oct':0,'Nov':0,'Dec':0,'Jan':0,'Feb':0,'Mar':0,'Apr':0,'May':0,'Jun':0};
    let regCount = {'Jul':0,'Aug':0,'Sep':0,'Oct':0,'Nov':0,'Dec':0,'Jan':0,'Feb':0,'Mar':0,'Apr':0,'May':0,'Jun':0};
    this.submissions.forEach((element) => {
     let month = new Date(element.Date).getMonth(); 
      switch (month) {
        case 6:
        atCount.Jul = atCount.Jul + Number(element.Attendance);
        if(element.Logged){
          regCount.Jul++;
        } 
        break;
        case 7:
        atCount.Aug = atCount.Aug + Number(element.Attendance);
        if(element.Logged){
          regCount.Aug++;
        } 
        break;
        case 8:
        atCount.Sep = atCount.Sep + Number(element.Attendance);
        if(element.Logged){
          regCount.Sep++;
        } 
        break;
        case 9:
        atCount.Oct = atCount.Oct + Number(element.Attendance);
        if(element.Logged){
          regCount.Oct++;
        } 
        break;
        case 10:
        atCount.Nov = atCount.Nov + Number(element.Attendance);
        if(element.Logged){
          regCount.Nov++;
        } 
        break;
        case 11:
        atCount.Dec = atCount.Dec + Number(element.Attendance);
        if(element.Logged){
          regCount.Dec++;
        } 
        break;
        case 0:
        atCount.Jan = atCount.Jan + Number(element.Attendance);
        if(element.Logged){
          regCount.Jan++;
        } 
        break;
        case 1:
        atCount.Feb = atCount.Feb + Number(element.Attendance);
        if(element.Logged){
          regCount.Feb++;
        } 
        break;
        case 2:
        atCount.Mar = atCount.Mar + Number(element.Attendance);
        if(element.Logged){
          regCount.Mar++;
        } 
        break;
        case 3:
        atCount.Apr = atCount.Apr + Number(element.Attendance);
        if(element.Logged){
          regCount.Apr++;
        } 
        break;
        case 4:
        atCount.May = atCount.May + Number(element.Attendance);
        if(element.Logged){
          regCount.May++;
        } 
        break;
        case 5:
        atCount.Jun = atCount.Jun + Number(element.Attendance);
        if(element.Logged){
          regCount.Jun++;
        } 
        break;
        
          default:
            break;
        } 
      
      
    })
    apData.lineAreaChartSpline.chartOptions.xaxis.categories = ['Jul','Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar','Apr','May','Jun'];
    //for the attendance
    apData.lineAreaChartSpline.series[0].data = [atCount.Jul,atCount.Aug,atCount.Sep,atCount.Oct,atCount.Nov,atCount.Dec,atCount.Jan,atCount.Feb,atCount.Mar,atCount.Apr,atCount.May,atCount.Jun,];
    //for the registered members
    apData.lineAreaChartSpline.series[1].data = [regCount.Jul,regCount.Aug,regCount.Sep,regCount.Oct,regCount.Nov,regCount.Dec,regCount.Jan,regCount.Feb,regCount.Mar,regCount.Apr,regCount.May,regCount.Jun,];
    return [apData.lineAreaChartSpline.chartOptions,  apData.lineAreaChartSpline.series];
    },
  },
  async mounted() {
    this.ready = true;

  },
  methods: {
    
  },

  components: {
    VueApexCharts
  }
}
</script>